'use client';

import { useEffect } from 'react';

interface AssistantFontReadyProps {
  fontFamily: string;
}

const ASSISTANT_FONT_SAMPLE = 'Assistant Working for 0s';
const ASSISTANT_FONT_WEIGHTS = [400, 500] as const;

export const AssistantFontReady = ({ fontFamily }: AssistantFontReadyProps) => {
  useEffect(() => {
    let active = true;
    const root = document.documentElement;
    const descriptors = ASSISTANT_FONT_WEIGHTS.map(weight => `${weight} 1em ${fontFamily}`);

    root.dataset.assistantFontStatus = 'loading';

    Promise.all(
      descriptors.map(descriptor => document.fonts.load(descriptor, ASSISTANT_FONT_SAMPLE))
    )
      .then(loadedFaces => {
        if (!active) return;

        const loadedEveryFace = loadedFaces.every(faces => faces.length > 0);
        const readyEveryWeight = descriptors.every(descriptor =>
          document.fonts.check(descriptor, ASSISTANT_FONT_SAMPLE)
        );
        root.dataset.assistantFontStatus =
          loadedEveryFace && readyEveryWeight ? 'ready' : 'failed';
      })
      .catch(() => {
        if (active) root.dataset.assistantFontStatus = 'failed';
      });

    return () => {
      active = false;
    };
  }, [fontFamily]);

  return null;
};
